const state = {
  isExpand: true,
};

const mutations = {
  mutExpandStatus: (state: any, status: boolean) => {
    state.isExpand = status;
  },
};

const actions = {
  setExpandStatus({ commit }: any, status: boolean) {
    commit('mutExpandStatus', status);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
